import { createContext } from 'react';

import { ModulePageConfigState } from './ModulePageConfigProvider.types';

export const ModulePageConfigContext = createContext<ModulePageConfigState>({});
